import { Controller } from '@hotwired/stimulus';
import { Tooltip } from 'bootstrap/dist/js/bootstrap.bundle.min.js';

export default class extends Controller {
  static targets = ['input', 'label', 'number'];
  static values = { expandMax: Boolean };

  connect() {
    if (!this.hasNumberTarget) this.tooltip = new Tooltip(this.element, {
      title: this.inputTarget.value,
      trigger: 'hover',
      animation: false
    });
    this.updateTooltip();

    this.inputTarget.addEventListener('input', this._onRangeInput);

    if (this.hasNumberTarget) {
      this.numberTarget.addEventListener('input', this._onNumberInput);
      this.numberTarget.addEventListener('change', this._onNumberChange);
    }
  }

  disconnect() {
    this.tooltip?.dispose();

    if (this.hasInputTarget) {
      this.inputTarget.removeEventListener('input', this._onRangeInput);
    }

    if (this.hasNumberTarget) {
      this.numberTarget.removeEventListener('input', this._onNumberInput);
      this.numberTarget.removeEventListener('change', this._onNumberChange);
    }
  }

  updateTooltip() {
    this.tooltip?.setContent({ '.tooltip-inner': this.inputTarget.value });
  }

  _onRangeInput = () => {
    if (this.hasNumberTarget) {
      this.numberTarget.value = this.inputTarget.value;
    }
    this.updateTooltip();
  };

  _onNumberInput = () => {
    const value = Number(this.numberTarget.value);
    if (this.expandMaxValue && Number.isFinite(value) && value > Number(this.inputTarget.max)) {
      this.inputTarget.max = Math.min(value, Number(this.numberTarget.max));
    }
    this.inputTarget.value = this.numberTarget.value;
    this.updateTooltip();
  };

  // Clamp value on blur / Enter so it stays within min–max
  _onNumberChange = () => {
    const min = Number(this.inputTarget.min);
    const max = Number(this.expandMaxValue ? this.numberTarget.max : this.inputTarget.max);
    let val = Number(this.numberTarget.value);

    if (!isNaN(min) && val < min) val = min;
    if (!isNaN(max) && val > max) val = max;

    if (this.expandMaxValue && val > Number(this.inputTarget.max)) this.inputTarget.max = val;
    this.inputTarget.value = val;
    // The native range normalizes to its step (e.g. odd grid widths).
    this.numberTarget.value = this.inputTarget.value;
    this.updateTooltip();

    // Trigger the same action the range slider would (e.g. form#submit)
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }));
  };
}
